const isLoginPage = (router) => router.pathname === '/login'
  || router.pathname === '/password/lost'
  || router.pathname === '/password/reset'
  || router.pathname === '/register';

export default isLoginPage;
